import { render, staticRenderFns } from "./GdprRequestDialog.vue?vue&type=template&id=16ccdf91"
import script from "./GdprRequestDialog.vue?vue&type=script&lang=js"
export * from "./GdprRequestDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports